import styled from 'styled-components';
import { colors } from '../../settings';
import Text from '../Text';

export const BackToTopButton = styled.div`
  margin: 45px auto;
  position: relative;
  text-align: center;
`;

export const StyledTextH3 = styled(Text.H3)`
  &:before {
    content: '';
    width: 14px;
    height: 14px;
    display: block;
    position: absolute;
    top: -5px;
    left: 50%;
    background: 0 0;
    border-top: solid 3px ${colors.red};
    border-left: solid 3px ${colors.red};
    transform: rotate(45deg) translate(-50%);
  }
`;
